import { Icon } from '@material-ui/core';
import { showAlert } from 'actions/client';
import * as Doka from 'libs/doka/doka.esm.min';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { BarLoader } from 'react-spinners';
import styled, { css } from 'styled-components';
import { FetchAllOptionGroupsAPIRequest } from 'utils/constants/network';
import ArrowDown from 'utils/images/arrow-down.svg';
import * as Yup from 'yup';
import { UploadVenueImageAPIRequest } from '../../../../../../utils/constants/network';
import PriceWithSymbol from '../../../../../../utils/currency/PriceWithSymbol';
import { callAPI } from '../../../../../../utils/network/index';
import AddButton from '../../components/shared/AddButton';
import Alert from '../../components/shared/Alert';
import Allergens from '../../components/shared/Allergens';
import CostPriceField from '../../components/shared/CostPriceField';
import VatRateField from '../../components/shared/VatRateField';
import DescriptionField from '../../components/shared/DescriptionField';
import EditorButtons from '../../components/shared/EditorButtons';
import EditorContainer from '../../components/shared/EditorContainer';
import EditorForm from '../../components/shared/EditorForm';
import NameField from '../../components/shared/NameField';
import PrepAreaSelect from '../../components/shared/PrepAreaSelect';
import PriceField from '../../components/shared/PriceField';
import RemoveButton from '../../components/shared/RemoveButton';
import StatusSelect from '../../components/shared/StatusSelect';
import { OPTION_GROUPS_MODALS, PATH_KEY_TO_POSITION } from '../../constants';
import {
  DispatchContext,
  StateContext,
} from '../../contexts/use-menu-editor-context';
import useEditor from '../../hooks/use-editor';
import {
  displayChoiceLimit,
  displayChoiceLimitHeader,
  displayPriceSubUnit,
} from '../../utils';
import {
  costPriceValidation,
  vatRateValidation,
  requiredLabel,
  requiredNameWithMaxLength,
  requiredParentId,
  requiredStatus,
} from '../../utils/validation';
import OptionGroupModals from '../GlobalOptions/option-group-modals';
import DeleteButton from '../shared/DeleteButton/index';
import EditButton from '../shared/EditButton';
import Required from '../shared/Required';
import { OptionGroupsToolTip } from '../shared/TooltipModals';
import VariantEditorList from './variant-editor-list';

const LEVEL = PATH_KEY_TO_POSITION['productIdx'];

const validation = Yup.object({
  name: requiredNameWithMaxLength,
  status: requiredStatus,
  label: requiredLabel,
  parent_id: requiredParentId,
  cost_price: costPriceValidation,
  vat_rate_eat_in: vatRateValidation,
  vat_rate_takeaway: vatRateValidation,
});

const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const AddGroupPanel = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  max-width: 720px;
  height: 60px;
  background: #f3f4f6;
  border: 1px solid #dedede;
  box-sizing: border-box;
  border-radius: 5px;
`;
const ExpanderArrow = styled.div`
  width: 12px;
  height: 7px;
  line-height: 12px;
  transform: rotate(270deg);
  cursor: pointer;

  ${props =>
    props.expanded &&
    css`
      transform: rotate(0deg);
      cursor: pointer;
      margin-top: -8px;
      margin-left: 0px;
    `}

  ${props =>
    props.hide &&
    css`
      visibility: hidden;
    `}
`;

const SelectedGroupsPanel = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 720px;
  padding: 11px;
  // height: 60px;
  margin-bottom: 5px;
  background: #f3f4f6;
  box-sizing: border-box;
  border: 1px solid #dedede;
  border-radius: 5px;

  ${props =>
    props.embedded &&
    css`
      background: white;
      margin-top: 20px;
    `}
`;

const PanelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 7px;
  ${props =>
    props.expanded &&
    css`
      height: 100%;
    `}
`;

const ImageBox = styled.div`
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #afafaf;
  overflow: hidden;
  margin-right: 16px;
`;

const FlexRow = styled.div`
  display: flex;
  margin: 30px 0px;
`;

const ProductNameRow = styled(FlexRow)`
  align-items: flex-end;
  margin: 15px 0px 30px 0px;
`;

const PriceFieldZeroVerticalMargin = styled(PriceField)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 3px;
  padding-top: 2px;
  margin: 0px 20px 0px 0px;
`;

const CostPriceFieldZeroVerticalMargin = styled(CostPriceField)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 3px;
  padding-top: 2px;
  margin: 0px 20px 0px 0px;
`;

const VatRateFieldZeroVerticalMargin = styled(VatRateField)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 3px;
  padding-top: 2px;
  margin: 0px 20px 0px 0px;
`;

const PrepAreaSelectZeroVerticalMargin = styled(PrepAreaSelect)`
  margin: 0px 20px 0px 0px;
`;

const StatusSelectZeroVerticalMargin = styled(StatusSelect)`
  margin: 0px 0px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 14px;
  cursor: pointer;
`;
const OptionsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const Header = styled.h3`
  font-family: 'Basier Circle';
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 15px !important;
  line-height: 16px;
  letter-spacing: -0.2px;
  color: #000000;
  margin-bottom: 0px; //figma 17px
`;
const OptionGroupHeader = styled.h3`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.2px;
  color: #000000;
  ${props =>
    props.expanded &&
    css`
      font-weight: 400;
    `};
`;

const PriceAndLimitContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 30px;
`;
const Limit = styled.p`
  margin: 0px;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
  letter-spacing: -0.2px;
  color: #000000;
  margin-top: -11px;
`;

const Wrapper = styled.div``;

const Edit = styled(EditButton)`
  background-color: #ffffff;
  border-radius: 50%;
`;
const SelectedOptionGroupContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 35px;
  padding-right: 146px;
`;
const SelectedChoiceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 3px;
  padding-bottom: 3px;
`;
const ChoiceWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const Price = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
  letter-spacing: -0.2px;
  color: #000000;
  margin-top: 3.2px;
`;
const LimitWrapper = styled.div`
  position: absolute;
  right: calc(35% + 28px);
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
  letter-spacing: -0.2px;
  color: #000000;

  @media only screen and (min-width: 375px) and (max-width: 900px) {
    padding-left: 10px;
    position: initial;
  }
`;
const ChoiceName = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  margin: 0;
`;
const doka = Doka.create(null, {
  outputType: 'image/jpeg',
  outputFit: 'cover',
  outputQuality: 80,
  outputWidth: 500,
  outputHeight: 500,
  size: { width: 500, height: 500 },
  cropAspectRatio: 1,
});

function ProductEditor(props) {
  const {
    product,
    menuIdx,
    categoryIdx,
    productIdx,
    onCancel,
    setShowEditor,
    parent,
  } = props;

  const {
    item,
    error,
    loading,
    childErrors,
    onChangeChild,
    onRemoveChild,
    onAddChild,
    onChildEditorSetup,
    onFieldChange,
    onCheckboxesChange,
    submitHandler,
    updateHandler,
    deleteHandler,
  } = useEditor({
    init: product || { status: 'live' },
    parent,
    validation,
    type: 'product',
    path: [
      { key: 'menuIdx', value: menuIdx },
      { key: 'categoryIdx', value: categoryIdx },
      { key: 'productIdx', value: productIdx },
    ],
    setShowEditor,
  });

  const {
    client,
    state: { optionGroups, isOgModalOpen, isManageMode },
  } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const [imageSrc, setImageSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const uploadImageRef = useRef(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [showSelectedOptions, setShowSelectedOptions] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [fetchingOptionGroups, setFetchingOptionGroups] = useState(false);
  const onNameChange = onFieldChange('name');
  const onImageChange = onFieldChange('image');
  const onPriceChange = onFieldChange('price');
  const onCostPriceChange = onFieldChange('cost_price');
  const onVatRateEatInChange = onFieldChange('vat_rate_eat_in');
  const onVatRateTakeawayChange = onFieldChange('vat_rate_takeaway');
  const onDescriptionChange = onFieldChange('description');
  const onLabelChange = onFieldChange('label');
  const onStatusChange = onFieldChange('status');
  const onAllergensSet = onFieldChange('allergens');
  const onAllergensChange = onCheckboxesChange('allergens');
  const onDietaryLabelsChange = onCheckboxesChange('dietaryLabels');

  const convertVenueImageUrlToCDNUrl = (imageUrl, width, height) => {
    const imageKey = imageUrl.split('/').pop();
    return `https://ik.imagekit.io/fatsomatabb/${
      process.env.REACT_APP_API_STAGE === 'prod' ? 'production/' : ''
    }${imageKey}?tr=w-${width},h-${height}`;
  };

  let appliedOptionGroups = [
    ...(optionGroups || []).filter(g =>
      g.productIds.some(id => id.includes('tbc'))
    ),
  ];

  let nonAppliedOptionGroups = [
    ...(optionGroups || []).filter(
      g =>
        g.productIds.length === 0 ||
        g.productIds.every(id => !id.includes('tbc'))
    ),
  ];

  let createMode = true;
  if (product) {
    createMode = false;
    appliedOptionGroups = (optionGroups || []).filter(g =>
      g.productIds.includes(product.id)
    );
    nonAppliedOptionGroups = (optionGroups || []).filter(
      g => !g.productIds.includes(product.id)
    );
  }

  useEffect(() => {
    if (item.image) {
      setImageSrc(convertVenueImageUrlToCDNUrl(item.image, 64, 64));
    }
  }, [item]);

  const setItemImageViaApi = async path => {
    onImageChange({ target: { value: path } });
  };

  const removeFile = async () => {
    setUploadingImage(true);

    try {
      setImageSrc(null);
      await setItemImageViaApi(null);
    } catch (e) {
      alert(`We could not remove the image: ${e.toString()}`);
    }

    setUploadingImage(false);
  };

  const onChangeFile = async event => {
    event.stopPropagation();
    event.preventDefault();

    const fileReader = new FileReader();
    const file = event.target.files[0];

    fileReader.onload = async () => {
      setImageSrc(fileReader.result);
      setUploadingImage(true);

      const apiRequest = UploadVenueImageAPIRequest({
        file_base64_data: fileReader.result,
        purpose: 'Menu Image',
      });

      try {
        const { file } = await callAPI(apiRequest);
        setImageSrc(convertVenueImageUrlToCDNUrl(file, 64, 64));

        await setItemImageViaApi(file);
      } catch (e) {
        setImageSrc(null);
        alert(`We could not upload the image: ${e.toString()}`);
      }

      setUploadingImage(false);
    };

    fileReader.onerror = () => {
      fileReader.abort();
    };

    doka.edit(file).then(output => {
      fileReader.readAsDataURL(output.file);
    });
  };
  const fetchAllOptionGroups = async () => {
    setFetchingOptionGroups(true);

    try {
      const apiRequest = FetchAllOptionGroupsAPIRequest({});
      const allOptionGroups = await callAPI(apiRequest);

      dispatch({
        type: 'UPDATE_OPTION_GROUPS',
        payload: {
          optionGroups: allOptionGroups,
        },
      });
    } catch (e) {
      console.error(e);
      showAlert('Failure', 'Sorry, we could not fetch your Groups.');
    } finally {
      setFetchingOptionGroups(false);
    }
  };

  useEffect(() => {
    fetchAllOptionGroups();
  }, []);

  const removeOptionGroupFromProduct = async groupId => {
    const groupToUpdate = optionGroups.find(g => g.id === groupId);
    const productIdsListedUnderGroup = groupToUpdate.productIds;
    let newProductIds;

    if (product) {
      newProductIds = productIdsListedUnderGroup.filter(
        productId => productId !== product.id
      );
    } else {
      newProductIds = productIdsListedUnderGroup.filter(
        productId => !productId.includes('tbc')
      );
    }
    const updatedGroup = { ...groupToUpdate, productIds: newProductIds };
    dispatch({
      type: 'UPDATE_OPTION_GROUPS',
      payload: {
        optionGroups: [
          ...optionGroups.filter(g => g.id !== groupToUpdate.id),
          updatedGroup,
        ],
      },
    });
    if (product) {
      await client.post('/update-option-group', updatedGroup);
    }
  };

  const editOptionGroupFromProduct = id => {
    const groupToEdit = optionGroups.find(g => g.id === id);
    dispatch({
      type: 'SET_OG_MODAL_MODE',
      payload: {
        ogModalMode: OPTION_GROUPS_MODALS.EDIT,
      },
    });

    dispatch({
      type: 'SET_GROUP_TO_EDIT',
      payload: {
        groupToEdit: groupToEdit,
      },
    });

    dispatch({
      type: 'TOGGLE_OG_MODAL',
      payload: {
        isOgModalOpen: true,
      },
    });
  };
  return (
    <EditorContainer level={LEVEL}>
      <EditorForm>
        <ProductNameRow>
          <ImageBox
            onClick={e => {
              e.stopPropagation();
              uploadImageRef.current.click();
            }}
            style={{
              background:
                imageSrc && !uploadingImage
                  ? `url(${imageSrc}) center center`
                  : 'white',
              backgroundSize: 'cover',
            }}
          >
            <input
              id="myInput"
              type="file"
              ref={uploadImageRef}
              style={{ display: 'none' }}
              onChange={onChangeFile}
            />

            {!imageSrc && !uploadingImage && <Icon>add_a_photo</Icon>}
            {uploadingImage && (
              <BarLoader color="#000" width={100} height={4} />
            )}

            {imageSrc && !uploadingImage && (
              <DeleteButton
                onClick={e => {
                  e.stopPropagation();
                  removeFile();
                }}
              />
            )}
          </ImageBox>

          <NameField
            margin="0px"
            id={`product-name-${item.id}`}
            type="product"
            value={item.name || ''}
            onChange={onNameChange}
            placeholder="e.g Eggs Benedict"
          />
        </ProductNameRow>
        <DescriptionField
          onChange={onDescriptionChange}
          value={item.description || ''}
        />
        <FlexRow>
          <PriceFieldZeroVerticalMargin
            id={`product-price-${item.id}`}
            onChange={onPriceChange}
            value={item.price || 0}
          />
          <CostPriceFieldZeroVerticalMargin
            id={`product-cost-price-${item.id}`}
            onChange={onCostPriceChange}
            value={item.cost_price || 0}
            price={item.price}
          />
          <PrepAreaSelectZeroVerticalMargin
            id={`product-prep-select-${item.id}`}
            value={item.label}
            onChange={onLabelChange}
          />
          <StatusSelectZeroVerticalMargin
            id={`product-status-select-${item.id}`}
            value={item.status}
            onChange={onStatusChange}
          />
        </FlexRow>
        <FlexRow>
          <VatRateFieldZeroVerticalMargin
            id={`product-vat-rate-eat-in-${item.id}`}
            label="Eat-in VAT %"
            onChange={onVatRateEatInChange}
            value={item.vat_rate_eat_in}
          />
          <VatRateFieldZeroVerticalMargin
            id={`product-vat-rate-takeaway-${item.id}`}
            label="Takeaway VAT %"
            onChange={onVatRateTakeawayChange}
            value={item.vat_rate_takeaway}
          />
        </FlexRow>
        <Allergens
          id={`allergens-select-${item.id}`}
          allergens={item.allergens || []}
          dietaryLabels={item.dietaryLabels || []}
          onAllergensSet={onAllergensSet}
          onAllergensChange={onAllergensChange}
          onDietaryLabelsChange={onDietaryLabelsChange}
        />
        <VariantEditorList
          variants={item.children || []}
          childErrors={childErrors}
          onAdd={onAddChild}
          onChange={onChangeChild}
          onRemove={onRemoveChild}
          onEditorSetup={onChildEditorSetup}
        />
        <OptionsHeaderWrapper>
          <Header>Customisation Options</Header>
          <OptionGroupsToolTip />
        </OptionsHeaderWrapper>
        {appliedOptionGroups.map(group => {
          return (
            <SelectedGroupsPanel expanded={showSelectedOptions[group.id]}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1px',
                }}
              >
                <PanelWrapper
                  expanded={showSelectedOptions[group.id]}
                  onClick={() => {
                    const groupStatus = {
                      ...showSelectedOptions,
                      [group.id]: !showSelectedOptions[group.id],
                    };
                    setShowSelectedOptions(groupStatus);
                  }}
                >
                  <ExpanderArrow
                    expanded={showSelectedOptions[group.id]}
                    id={`${group.id}`}
                  >
                    <img alt="expand arrow" src={ArrowDown} />
                  </ExpanderArrow>
                  <HeaderWrapper expanded={!showSelectedOptions[group.id]}>
                    <OptionGroupHeader
                      expanded={!showSelectedOptions[group.id]}
                    >
                      {group.name}
                      {group.required && <Required>Required</Required>}
                      {showSelectedOptions[group.id] && (
                        <LimitWrapper mitWrapper>
                          {group.variantType === 'multiple'
                            ? displayChoiceLimitHeader(group.choice_limit)
                            : null}
                        </LimitWrapper>
                      )}
                    </OptionGroupHeader>
                  </HeaderWrapper>
                </PanelWrapper>

                <ButtonWrapper>
                  <Edit onClick={() => editOptionGroupFromProduct(group.id)} />
                  <RemoveButton
                    variant="outlined"
                    color="primary"
                    onClick={() => removeOptionGroupFromProduct(group.id)}
                  >
                    Remove
                  </RemoveButton>
                </ButtonWrapper>
              </div>
              <Wrapper>
                {showSelectedOptions[group.id] &&
                  (group.children || []).map(g => {
                    return (
                      <SelectedOptionGroupContainer>
                        <SelectedChoiceWrapper>
                          <ChoiceWrapper>
                            <ChoiceName>{g.name}</ChoiceName>
                          </ChoiceWrapper>
                        </SelectedChoiceWrapper>
                        <PriceAndLimitContainer>
                          <Price>
                            +{' '}
                            <PriceWithSymbol
                              price={displayPriceSubUnit(g.price)}
                            />
                          </Price>
                          {group.variantType === 'multiple' && (
                            <Limit>{displayChoiceLimit(g.choice_limit)}</Limit>
                          )}
                        </PriceAndLimitContainer>
                      </SelectedOptionGroupContainer>
                    );
                  })}
              </Wrapper>
            </SelectedGroupsPanel>
          );
        })}
        <AddGroupPanel>
          <AddButtonWrapper>
            <AddButton
              variant="outlined"
              color="primary"
              onClick={() => {
                dispatch({
                  type: 'TOGGLE_OG_MODAL',
                  payload: {
                    isOgModalOpen: true,
                  },
                });
                dispatch({
                  type: 'SET_OG_MODAL_MODE',
                  payload: {
                    ogModalMode:
                      (optionGroups || []).length === 0
                        ? OPTION_GROUPS_MODALS.CREATE
                        : OPTION_GROUPS_MODALS.LIST,
                  },
                });
              }}
            >
              Add options
            </AddButton>
          </AddButtonWrapper>
        </AddGroupPanel>
        {isOgModalOpen && (
          <OptionGroupModals
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            parent={parent}
            groups={nonAppliedOptionGroups}
            allGroups={optionGroups}
            product={product}
            setGroups={newGroups =>
              dispatch({
                type: 'UPDATE_OPTION_GROUPS',
                payload: {
                  optionGroups: newGroups,
                },
              })
            }
            close={() => {
              dispatch({
                type: 'TOGGLE_OG_MODAL',
                payload: {
                  isOgModalOpen: false,
                },
              });

              if (isManageMode) {
                dispatch({
                  type: 'TOGGLE_IS_MANAGE_MODE',
                  payload: {
                    isManageMode: false,
                  },
                });
              }
            }}
            fetchAllOptionGroups={fetchAllOptionGroups}
          />
        )}
        <EditorButtons
          type="product"
          create={createMode}
          loading={loading}
          onCancel={onCancel}
          onSubmit={() =>
            submitHandler(productId => {
              const ogsToUpdate = appliedOptionGroups.map(og => {
                return {
                  ...og,
                  productIds: og.productIds.map(ogProductId => {
                    if (ogProductId.includes('tbc')) {
                      return productId;
                    }
                    return ogProductId;
                  }),
                };
              });

              const ogUpdates = ogsToUpdate.map(og => {
                return client.post('/update-option-group', og);
              });

              const optionGroupIdsToUpdate = ogsToUpdate.map(og => og.id);

              const newOgs = optionGroups.map(og =>
                optionGroupIdsToUpdate.includes(og.id)
                  ? ogsToUpdate.find(ogUpdated => ogUpdated.id === og.id)
                  : og
              );

              dispatch({
                type: 'UPDATE_OPTION_GROUPS',
                payload: {
                  optionGroups: newOgs,
                },
              });

              Promise.all(ogUpdates)
                .then(() => {
                  console.log('All option groups updated successfully');
                })
                .catch(err => {
                  console.log(err);
                });
            })
          }
          onUpdate={updateHandler}
          onDelete={deleteHandler}
        />
      </EditorForm>
      {error ? <Alert>{error}</Alert> : null}
    </EditorContainer>
  );
}

export default ProductEditor;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/ProductList/product-editor.jsx